import styled from 'styled-components'

import { color, font } from '~/styles/utils'

export const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 17px;
  ${font('base')};
  color: ${color('darkGrey')};
`
